import './ReferralVendorForm.scss'
import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import _ from 'lodash'
import { connect } from 'react-redux'
import cx from 'classnames'
import FeedbackTextbox from 'common/views/components/FeedbackTextbox'
import FeedbackSelect from 'common/views/components/FeedbackSelect'
import { connectModal, show as showModal } from 'redux-modal'
import { setEditMortgageCompany, setEditTitleCompany, selectMortgageCompany, selectTitleCompany,
  updateMortgageOptOut, updateTitleOptOut
} from 'manager/redux/referral_status'
import { LOAN_OPT_OUT_REASONS, SETTLEMENT_OPT_OUT_REASONS } from 'common/constants'
import { scrollToTop } from 'manager/util/helper'
import {AddButton, SaveButton} from "manager/views/components/ReferralStatus/Common/ReferralSatusButtons"


const ReferralOptOut = ({ show, handleHide }) => {
  return (
    <Modal show={show} className="RMBarModal">
      <Modal.Header>
        <Modal.Title>Why do we ask this?</Modal.Title>
        <div onClick={handleHide} className="RMBarModal__image-close"/>
      </Modal.Header>

      <Modal.Body>
        <div className="text">
          <div>There are many good service providers for clients to choose from and, at Opcity, we encourage clients to shop around to determine that they are receiving the best possible rates and services. So that we can continue to offer quality options to homebuyers, we want to better understand why chosen partners are the best fits for clients.</div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
const ReferralOptOutModal = connectModal({ name: 'ReferralOptOutModal', destroyOnHide: true })(ReferralOptOut)

class OptOutForm extends Component {
  state = {
    companyName: null,
    officerName: null,
    reason: null,
    refer: false,
    email: null,
    phone: null,
    companyNameError: null,
    emailError: null,
    reasonsError: null,
  }

  validate = () => {
    const { companyLabel, hasActiveAssignment, optOutCompany } = this.props
    const { companyName, email, reason, refer } = this.state

    this.setState({
      companyNameError: null,
      emailError: null,
      reasonError: null,
    })

    let valid = true
    if (!companyName || companyName === '') {
      this.setState({companyNameError: `${companyLabel} name is required`})
      valid = false
    }

    if (refer && (!email || email === '')) {
      this.setState({emailError: 'Email is required'})
      valid = false
    }

    if (hasActiveAssignment && !optOutCompany && (!reason || reason === '')) {
      this.setState({reasonError: 'Reason is required'})
      valid = false
    }

    return valid
  }

  handleSave = () => {
    const { optOut, select, edit } = this.props
    const { companyName, officerName, refer, email, phone, reason } = this.state

    if (this.validate()) {
      optOut(companyName, officerName, refer, email, phone, [reason])
      select('optOut')
      edit(false)
    }
  }

  render() {
    const { companyLabel, officerLabel, hasActiveAssignment, assignmentCompany, optOutCompany, reasons, showModal } = this.props

    const optOutReasons = hasActiveAssignment && !optOutCompany && (
        <div>
          <div className="ReferralVendorForm__label">Reasons</div>
          <a className="ReferralVendorForm__why" onClick={() => showModal('ReferralOptOutModal', {initialState: {}})}>Why do we ask this?</a>
          <div className="ReferralVendorForm__description">{`Please choose the reason why your client did not choose ${assignmentCompany} after their initial discussion.`}</div>
          <div className="ReferralVendorForm__label">{`${assignmentCompany}...`}</div>
          <FeedbackSelect
            options={reasons}
            value={this.state.reason}
            onChange={option => this.setState({reason: option && option.value})}
            errorMsg={this.state.reasonError} />
        </div>
      )

    const referral = this.state.refer && (
        <div className="ReferralVendorForm__referral">
          <div className="ReferralVendorForm__label">Email</div>
          <FeedbackTextbox
            value={this.state.email}
            placeholder=""
            onChange={e => this.setState({email: e.target.value})}
            errorMsg={this.state.emailError}
            onFocus={scrollToTop} />
          <div className="ReferralVendorForm__label">Phone</div>
          <FeedbackTextbox
            value={this.state.phone}
            placeholder=""
            onChange={e => this.setState({phone: e.target.value})}
            errorMsg={null}
            onFocus={scrollToTop} />
        </div>
      )

    return (
      <div className="ReferralVendorForm__form">
        <div className="ReferralVendorForm__label">{`${companyLabel} Name`}</div>
        <FeedbackTextbox
          value={this.state.companyName}
          placeholder=""
          onChange={e => this.setState({companyName: e.target.value})}
          errorMsg={this.state.companyNameError}
          onFocus={scrollToTop} />
        <div className="ReferralVendorForm__label">{`${officerLabel} Name`}</div>
        <FeedbackTextbox
          value={this.state.officerName}
          placeholder=""
          onChange={e => this.setState({officerName: e.target.value})}
          errorMsg={null}
          onFocus={scrollToTop} />
        { optOutReasons }
        <div className="ReferralVendorForm__refer">
          <label
            htmlFor="confirm_refer_title_provider"
            className="ReferralVendorForm__check_label"
            >Refer to the Opcity {companyLabel} Network</label>
          <input
            id="confirm_refer_title_provider"
            type="checkbox"
            className="ReferralVendorForm__check"
            checked={this.state.refer}
            onChange={() => this.setState(prev => ({refer: !prev.refer}))}
            onFocus={scrollToTop} />
        </div>
        { referral }
        <SaveButton onSave={this.handleSave}/>
      </div>
    )
  }

}

const RadioOptions = (props) => {
  const { selected, select, hasActiveAssignment, optOutCompany, companyLabel, edit } = props
  return (
    <div className="ReferralVendorForm__radio_options">
      {
        hasActiveAssignment && <div className={cx('ReferralVendorForm__option', {'ReferralVendorForm__selected': selected === 'assigned'})} onClick={() => select('assigned')}>
          <div className="ReferralVendorForm__radio"><div className="ReferralVendorForm__radio_inner"/></div>
          <AssignmentCompany {...props}/>
        </div>
      }
      {
        optOutCompany && <div className={cx('ReferralVendorForm__option', {'ReferralVendorForm__selected': selected === 'optOut'})} onClick={() => select('optOut')}>
          <div className="ReferralVendorForm__radio"><div className="ReferralVendorForm__radio_inner"/></div>
          <OptOutCompany {...props}/>
        </div>
      }
      <div className={cx('ReferralVendorForm__option', {'ReferralVendorForm__selected': selected === 'other'})} onClick={() => select('other')}>
        <div className="ReferralVendorForm__radio"><div className="ReferralVendorForm__radio_inner"/></div>
        <div className="ReferralVendorForm__other">{`Use Different ${companyLabel}...`}</div>
      </div>
      { selected === 'other' && <OptOutForm {...props}/> }
      { selected !== 'other' && <SaveButton onSave={() => {edit(false)}}/> }
    </div>

  )
}

const VendorCard = ({ company, officer, logo, network, companyLabel, edit, disclosure }) => {
  const onClick = () => {
    if (disclosure) {
      edit(true)
    }
  }

  return (
    <div className="ReferralVendorForm__vendor" onClick={onClick}>
      <div className="ReferralVendorForm__vendor_inner">
        { network && <div className="ReferralVendorForm__network">{`Opcity Network ${companyLabel}`}</div> }
        <div>
          { logo ? <img src={logo} className="ReferralVendorForm__logo"/> : <div className="ReferralVendorForm__logo_container"><div className="ReferralVendorForm__logo_placeholder"/></div> }
          <div className="ReferralVendorForm__details">
            <div className="ReferralVendorForm__company">{ company }</div>
            <div className="ReferralVendorForm__officer">{ officer }</div>
          </div>
        </div>
      </div>
      { disclosure && <div className="ReferralVendorForm__disclosure"><i className="fa fa-angle-right"/></div> }
    </div>
  )
}

const AssignmentCompany = ({ assignmentCompany, assignmentOfficer, assignmentLogo, companyLabel, edit, disclosure }) => {
  return <VendorCard
    company={assignmentCompany}
    officer={assignmentOfficer}
    logo={assignmentLogo}
    network={true}
    companyLabel={companyLabel}
    edit={edit}
    disclosure={disclosure}
  />
}

const OptOutCompany = ({ optOutCompany, optOutOfficer, companyLabel, edit, disclosure }) => {
  return <VendorCard
    company={optOutCompany}
    officer={optOutOfficer}
    companyLabel={companyLabel}
    edit={edit}
    disclosure={disclosure}
  />
}

const ReferralVendorForm = (props) => {
  const { editing, edit, selected, hasActiveAssignment, optOutCompany, addLabel } = props

  let component
  if (!editing) {
    if (!selected) {
      component = <AddButton onClick={() => edit(true)}>{ addLabel }</AddButton>
    } else {
      if (selected === 'assigned') {
        component = <AssignmentCompany disclosure={true} {...props}/>
      } else if (selected === 'optOut') {
        component = <OptOutCompany disclosure={true} {...props}/>
      }
    }
  } else {
    if (hasActiveAssignment || optOutCompany) {
      component = <RadioOptions {...props}/>
    } else {
      component = <OptOutForm {...props}/>
    }
  }

  return (
    <div className="ReferralVendorForm">
      { component }
      <ReferralOptOutModal/>
    </div>
  )
}

const mortgageSelector = state => {
  const hasActiveAssignment = _.get(state, ['referral', 'referral', 'has_active_loan_assignment'])
  const assignmentCompanyInternal = _.get(state, ['referral', 'referral', 'loan_broker_company'])
  const assignmentCompany = _.get(state, ['referral', 'referral', 'loan_broker_profile_name']) || assignmentCompanyInternal
  const assignmentOfficer = _.get(state, ['referral', 'referral', 'loan_officer_name'])
  const assignmentLogo = _.get(state, ['referral', 'referral', 'loan_broker_logo'])
  const savedOptOutCompany = _.get(state, ['referral', 'referral', 'loan_opt_out_company'])
  const savedOptOutOfficer = _.get(state, ['referral', 'referral', 'loan_opt_out_officer'])
  const optOutCompany = _.get(state, ['referralStatus', 'loan_opt_out_company']) || savedOptOutCompany
  const optOutOfficer = _.get(state, ['referralStatus', 'loan_opt_out_officer']) || savedOptOutOfficer
  const selected = _.get(state, ['referralStatus', 'lender'])
  const editing = _.get(state, ['referralStatus', 'editMortgageCompany'], false)
  const addLabel = 'Add Lender'
  const companyLabel = 'Lender'
  const officerLabel = 'Loan Officer'
  const reasons = LOAN_OPT_OUT_REASONS

  return {
    hasActiveAssignment,
    assignmentCompany,
    assignmentOfficer,
    assignmentLogo,
    optOutCompany,
    optOutOfficer,
    selected,
    addLabel,
    companyLabel,
    officerLabel,
    reasons,
    editing,
  }
}
const mortgageActions = {
  edit: setEditMortgageCompany,
  select: selectMortgageCompany,
  optOut: updateMortgageOptOut,
  showModal,
}
const mortgageWithRedux = connect(mortgageSelector, mortgageActions)

const titleSelector = state => {
  const hasActiveAssignment = _.get(state, ['referral', 'referral', 'has_active_settlement_assignment'])
  const assignmentCompanyInternal = _.get(state, ['referral', 'referral', 'settlement_broker_company'])
  const assignmentCompany = _.get(state, ['referral', 'referral', 'settlement_broker_profile_name']) || assignmentCompanyInternal
  const assignmentOfficer = _.get(state, ['referral', 'referral', 'settlement_officer_name'])
  const assignmentLogo = _.get(state, ['referral', 'referral', 'settlement_broker_logo'])
  const savedOptOutCompany = _.get(state, ['referral', 'referral', 'settlement_opt_out_company'])
  const savedOptOutOfficer = _.get(state, ['referral', 'referral', 'settlement_opt_out_officer'])
  const optOutCompany = _.get(state, ['referralStatus', 'settlement_opt_out_company']) || savedOptOutCompany
  const optOutOfficer = _.get(state, ['referralStatus', 'settlement_opt_out_officer']) || savedOptOutOfficer
  const selected = _.get(state, ['referralStatus', 'settlement'])
  const editing = _.get(state, ['referralStatus', 'editTitleCompany'], false)
  const addLabel = 'Add Title Services Provider'
  const companyLabel = 'Title Services Provider'
  const officerLabel = 'Title Officer'
  const reasons = SETTLEMENT_OPT_OUT_REASONS

  return {
    hasActiveAssignment,
    assignmentCompany,
    assignmentOfficer,
    assignmentLogo,
    optOutCompany,
    optOutOfficer,
    selected,
    addLabel,
    companyLabel,
    officerLabel,
    reasons,
    editing,
  }
}
const titleActions = {
  edit: setEditTitleCompany,
  select: selectTitleCompany,
  optOut: updateTitleOptOut,
  showModal,
}
const titleWithRedux = connect(titleSelector, titleActions)

export const MortgageForm = mortgageWithRedux(ReferralVendorForm)
export const LegacyReferralTitleForm = titleWithRedux(ReferralVendorForm)





